import lodash from 'lodash'
export default {
  getListChecklistItem (state, payload) {
    state.checklist_items = payload.data ? payload.data : []
    state.last_page = payload.meta ? payload.meta.last_page : 0
    state.total = payload.meta ? payload.meta.total : 0
  },
  destroyChecklistItem (state, payload) {
    var index = lodash.findIndex(state.checklist_items, ['id', payload.id])
    state.checklist_items.splice(index, 1)
    state.total -= 1
  },
  createChecklistItem (state, payload) {
    state.checklist_items.unshift(payload)
  },
  openEdit (state, payload) {
    state.open_edit = true
    state.open_create_children = false
    state.open_view = false
    state.open_checklist_item = false
  },
  closeEdit (state, payload) {
    state.open_edit = false
    state.open_view = true
    state.open_create_children = false
    state.open_checklist_item = false
  },
  openCreateChildren (state, payload) {
    state.open_create_children = true
    state.open_edit = false
    state.open_view = false
    state.open_checklist_item = false
  },
  closeCreateChildren (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = true
    state.open_checklist_item = false
  },
  openView (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = true
    state.open_checklist_item = false
  },
  closeView (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = false
    state.open_checklist_item = false
  },
  openChecklistItem (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = false
    state.open_checklist_item = true
  },
  closeChecklistItem (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = true
    state.open_checklist_item = false
  },
  updateChecklistItem (state, payload) {
    state.checklist_items = state.checklist_items.map(item => {
      if (parseInt(item.id) === parseInt(payload.id)) {
        item = payload
      }
      return item
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/checklist-item/mutations.js